import { useEffect, useState } from "react";

import { AnimationData } from "../../assets/glb/animations";
import { AccessibilityPopup } from "../../components/AccessibilityPopup";
import { CompleteChat } from "../../components/CompleteChat";
import { GlossaryComponent } from "../../components/GlossaryComponent";
import { Header } from "../../components/Header";
import { InitialChat } from "../../components/InitialChat";
import { LisaHome } from "../../components/LisaHome";
import { AIButton as AiButton, AiContainer, ContentContainer, MainContainer, OpenButton, PageContainer } from "./styles";
import { TabBar } from "../../components/TabBar";
import { EmailInput } from "../../components/EmailInput";
import { Attendant } from "../../components/Attendant";
import { useNavigate } from "react-router-dom";
import { Feedback } from "../../components/Feedback";
import AiInput from "../../components/AiInput";
import AiChat from "../../components/AiChat";
import { Sidebar } from "../../components/SideBar";
import { LibrasReplyPopup } from "../../components/LibrasReplyPopup";
import { Conversation, deleteConversation, generateId } from "../../utils/conversationStorage";
import { Scenario } from "../../utils/scenarioStorage";
import chatIcon from "../../assets/icons/chat.svg";
import AiIcon from "../../assets/icons/AI-button.svg"
import { TourGuide } from "../../components/TourGuide";
import { tourSteps } from "../../components/TourGuide/steps";


function newConversation(): Conversation {
  return {
    id: generateId(),
    title: "Nova conversa",
    messages: [
    ],
    createdAt: new Date(),
  };
}

export function HomePage() {
  const [animation, setAnimation] = useState<AnimationData[]>([]);
  const [headerAnimation, setHeaderAnimation] = useState<AnimationData[]>([]);
  const [repeat, setRepeat] = useState(false);
  const [startChat, setStartChat] = useState<{
    active: boolean;
    chosenOptionName?: string;
    chosenOptionIndex?: number;
  }>({ active: false });
  const [activeTab, setActiveTab] = useState("home");
  const [isAccessibilityOpen, setIsAccessibilityOpen] = useState(false);
  const [scenarioName, setScenarioName] = useState<string>();
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [showFeedbackInput, setShowFeedbackInput] = useState(false);
  const [headerPage, setHeaderPage] = useState(0);
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const [activeConversation, setActiveConversation] = useState<Conversation | null>(null);
  const [currentConversation, setCurrentConversation] = useState<Conversation>(newConversation);
  const [OpenMobileAi, setOpenMobileAi] = useState(false);
  const [subjectToAsk, setSubjectToAsk] = useState<string | undefined>(undefined);
  const [openAi, setopenAi] = useState(false);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [isAiProcessing, setIsAiProcessing] = useState(false);
  const [expandTrigger, setExpandTrigger] = useState(0);
  const [AiMode, setAiMode] = useState(false);

  function setAiChat(bool: boolean) {
    if (bool) {
      if (isMobile) {
        setOpenMobileAi(true);
      }
      setopenAi(true);
    } else {
      setOpenMobileAi(false);
      setopenAi(false);
    }
  }

  function closeAiMode(bool:boolean){
    setAiMode(false)
    setAiChat(false)
  }
  

  useEffect(() => {
    const scenarios = localStorage.getItem("scenarios");
    if (!scenarios) navigate("/");
  }, []);

  const closeTour = () => {
    setIsTourOpen(false);
  };

  useEffect(() => {
    if (activeConversation) {
      setCurrentConversation(activeConversation);
    }
  }, [activeConversation]);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 769);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const openChat = () => {
    if(isMobile){
      setOpenMobileAi(true)
       setAiChat(true)
    }
    else{
       setAiChat(true)
    }
  }

  const toggleFullSceen = (): void => {
    process.env.REACT_APP_ENABLE_TOGGLE_FULLSCREEN === "true"
      ? document.body.requestFullscreen()
      : {};
  };

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    if (tab !== "scenario") {
      setStartChat({ active: false });
      setScenarioName(undefined);
      setShowEmailInput(false);
      setShowFeedbackInput(false);
      setHeaderPage(0);
    }
  };


  return (
    <>
      <PageContainer>
      <LibrasReplyPopup active={activeTab === "scenario" || activeTab === "glossary" || activeTab === "home"}/>
      <Header
        backToHome={() => {
          setActiveTab("home");
          setStartChat({ active: false });
          setScenarioName(undefined);
          setShowEmailInput(false);
          setShowFeedbackInput(false);
          setHeaderPage(0);
        }}
        scenarioName={scenarioName}
        onBack={() => {
          if (headerPage === 0) {
            setStartChat({ active: false });
            setScenarioName(undefined);
          }
          setShowEmailInput(false);
          setHeaderPage(0);
          setShowFeedbackInput(false);
        }}
        onImportClick={() => {
          setShowEmailInput(true);
          setHeaderPage(1);
        }}
        headerPage={headerPage}
        onEvalClick={() => {
          setShowFeedbackInput(true);
          setHeaderPage(2);
        }}
        toggleSidebar={() => setShowSidebar(!showSidebar)}
        showSidebar={showSidebar}
        isAccessibilityOpen={isAccessibilityOpen}
        Aimode={AiMode}
        closeAimode={closeAiMode}
        setIsAccessibilityOpen={setIsAccessibilityOpen}
      />

      <Sidebar
        open={showSidebar}
        onClose={() => setShowSidebar(false)}
        onOpenTutorial={() => {
          setIsTourOpen(true);
          setShowSidebar(false);
        }}
        activeConversationId={currentConversation.id}
        onSelectConversation={(conv) => {
          setActiveConversation(conv);
          setShowSidebar(false);
        }}
        onDeleteConversation={(id) => {
          deleteConversation(id);
          if (currentConversation.id === id) {
            setActiveConversation(null);
            setCurrentConversation(newConversation());
          }
        }}
        onNewConversation={() => {
          setActiveConversation(null);
          setCurrentConversation(newConversation());
          setShowSidebar(false);
        }}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        setActiveChat={setAiChat}
      />
      <AccessibilityPopup
        isOpen={isAccessibilityOpen}
        onClose={() => setIsAccessibilityOpen(false)}
      />

      <MainContainer  onClick={() => toggleFullSceen()}>

        <div  className={`LisaContainer ${activeTab === "home" ? "home-active" : ""} ${isTourOpen ? "tour-active" : ""}`}>   
          
          { (!AiMode &&  activeTab === "home") && <AiButton disabled={false} onClick={() => { setAiMode(true)}}>
            <img src={AiIcon} alt="Inteligência Artificial" />
            Modo IA
          </AiButton>}

          <LisaHome
          animation={animation}
          repeat={repeat}
          setRepeat={setRepeat}
          setAnimation={setAnimation}
            headerAnimation={headerAnimation}
            isHomeActive={activeTab === "home"}
              showTimer={activeTab !== "home"}
            />

          </div>
          {activeTab === "home" && (
            openAi ? (
              <AiContainer $isMinimized={!OpenMobileAi} data-tutorial="expand-chat">
                <AiChat
                  messages={currentConversation.messages}
                  setAnimation={setAnimation}
                  onMinimizedChange={(minimized) => setOpenMobileAi(!minimized)}
                  onSubjectClick={setSubjectToAsk}
                  setOpenAi={(bool) => (setAiChat(bool))}
                  isMobile={isMobile}
                  isTyping={isAiProcessing}
                  expandTrigger={expandTrigger}
                />

                <AiInput
                  setAnimation={setAnimation}
                  currentConversation={currentConversation}
                  setCurrentConversation={setCurrentConversation}
                  activeConversation={activeConversation}
                  onConversationChange={() => setActiveConversation(null)}
                  presetText={subjectToAsk}
                  onPresetConsumed={() => setSubjectToAsk(undefined)}
                  isProcessing={isAiProcessing}
                  setIsProcessing={setIsAiProcessing}
                />
              </AiContainer>
            ) : (
              <div>
                {AiMode && (
                  <OpenButton className="hint" data-tutorial="chat-button" data-hint="Abrir chat" data-hint-placement="top-left" onClick={() => openChat()}>
                    <img src={chatIcon} alt="abrir chat" />
                  </OpenButton>
                )}
              </div>
            )



          )}

          {activeTab === "scenario" && (
            <ContentContainer>
              {startChat.active ? (
                showEmailInput ? (
                  <EmailInput
                    setAnimation={setAnimation}
                    // setSocketResponse={setSocketResponse}
                    onBack={() => {
                      setHeaderPage(0);
                      setShowEmailInput(false);
                      setShowFeedbackInput(false);
                    }}
                    scenarioName={scenarioName}
                    scenarioId={startChat.chosenOptionIndex ?? 0}
                  />
                ) : showFeedbackInput ? (
                  <Feedback
                    setAnimation={setAnimation}
                    // setSocketResponse={setSocketResponse}
                    onBack={() => {
                      setHeaderPage(0);
                      setShowEmailInput(false);
                      setShowFeedbackInput(false);
                    }}
                    scenarioName={scenarioName}
                    scenarioId={startChat.chosenOptionIndex}
                  />
                ) : (
                  <CompleteChat
                    setAnimation={setAnimation}
                    scenarioName={scenarioName}
                    scenarioId={startChat.chosenOptionIndex ?? 0}
                    onBack={() => {
                      setStartChat({ active: false });
                      setScenarioName(undefined);
                      setShowEmailInput(false);
                      setHeaderPage(0);
                      setShowFeedbackInput(false);
                    }}
                    onImportClick={() => setShowEmailInput(true)}
                    onEvalClick={() => setShowFeedbackInput(true)}
                  />
                )
              ) : (
                <InitialChat
                  animation={animation}
                  setAnimation={setAnimation}
                  setRepeat={setRepeat}
                  setHeaderAnimation={setHeaderAnimation}
                  // setSocketResponse={setSocketResponse}
                  setStartChat={setStartChat}
                  setScenarioName={setScenarioName}
                  scenarioId={startChat.chosenOptionIndex ?? 0}
                  onBack={() => setStartChat({ active: false })}
                />
              )}
            </ContentContainer>
          )}

          {activeTab === "glossary" && (
            <ContentContainer>
              <GlossaryComponent
                setAnimation={setAnimation}
                setHeaderAnimation={setHeaderAnimation}
                onBack={() => setActiveTab("home")}
              />
            </ContentContainer>
          )}
          {activeTab === "attendance" && (
            <ContentContainer>
              <Attendant
                setAnimation={setAnimation}
                onBack={() => setActiveTab("home")}
              />
            </ContentContainer>

          )}
        </MainContainer>
        <TourGuide
          steps={tourSteps}
          isOpen={isTourOpen}
          onClose={closeTour}
          setOpenAi={setAiChat}
          setAnimation={setAnimation}
          isMobile={isMobile}
          setExpanded={() => setExpandTrigger((n) => n + 1)}
        />
        { !AiMode && 
        <TabBar
          activeTab={activeTab}
          setActiveTab={handleTabChange}
          setAcessibility={setIsAccessibilityOpen}
        // onAccessibilityClick={(IsOpen: boolean) => setIsAccessibilityOpen(IsOpen)}
      />}
      </PageContainer>
    </>
  );
}